import themeColours from './styles/colours';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'typeface-roboto/index.css';

export default {
  icons: {
    iconfont: 'md' as 'md',
  },
  theme: {
    themes: {
      light: {
        ...themeColours,
      },
      dark: {
        accent: themeColours.accent,
        primary: themeColours.primary,
        neutral: {
          darken4: themeColours.neutral.lighten5,
          darken3: themeColours.neutral.lighten4,
          darken2: themeColours.neutral.lighten3,
          darken1: themeColours.neutral.lighten2,
          base: themeColours.neutral.lighten1,
          lighten1: themeColours.neutral.base,
          lighten2: themeColours.neutral.darken1,
          lighten3: themeColours.neutral.darken2,
          lighten4: themeColours.neutral.darken3,
          lighten5: themeColours.neutral.darken4,
        },
      },
    },
  },
};
